/* Power of the Almond: site pages (nav, quick add, product page). Loaded by layout/lp2.liquid. */
(function () {
  'use strict';
  var doc = document;
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function money(c, fmt) {
    var n = (c / 100).toFixed(2), s = n.replace(/\.00$/, '') === n ? n : n;
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        doc.documentElement.classList.add('lp2-has-items');
        if (window.LP2Cart) window.LP2Cart.open(true); else location.href = '/cart';
        return j;
      });
  }

  /* Mobile menu */
  function nav() {
    var box = $('[data-nav]'), btn = $('[data-nav-open]'); if (!box || !btn) return;
    function set(on) {
      box.hidden = !on; btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      doc.documentElement.classList.toggle('lp2-nav-on', on);
      if (on) { var f = $('a', box); if (f) f.focus(); } else btn.focus();
    }
    btn.addEventListener('click', function () { set(box.hidden); });
    $$('[data-nav-close]', box).forEach(function (x) { x.addEventListener('click', function () { set(false); }); });
    $$('a', box).forEach(function (a) { a.addEventListener('click', function () { box.hidden = true; doc.documentElement.classList.remove('lp2-nav-on'); }); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) set(false); });
  }

  /* One-tap add buttons anywhere: data-qa="variantId" */
  function quick() {
    doc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qa]'); if (!b || b.disabled) return;
      e.preventDefault();
      var label = b.textContent; b.disabled = true; b.classList.add('is-busy');
      addItems([{ id: +b.dataset.qa, quantity: 1 }]).then(function () {
        b.textContent = 'Added'; b.classList.add('is-done');
        setTimeout(function () { b.textContent = label; b.classList.remove('is-done'); }, 1800);
      }).catch(function (err) {
        b.textContent = (err && err.description) ? 'Unavailable' : 'Try again';
        setTimeout(function () { b.textContent = label; }, 2200);
      }).then(function () { b.disabled = false; b.classList.remove('is-busy'); });
    });
  }

  /* Product page */
  function pdp() {
    var root = $('[data-lp2-pdp]'); if (!root) return;
    var cfg = {}; try { cfg = JSON.parse($('[data-pdp-cfg]', root).textContent); } catch (e) {}
    var form = $('[data-pdp-form]', root), addBtn = $('[data-pdp-add]', root), tot = $('[data-pdp-total]', root);
    var nudge = $('[data-pdp-nudge]', root), err = $('[data-pdp-err]', root), sel = $('[data-pdp-variant]', root);
    var price = $('[data-pdp-price]', root), barp = $('[data-pdp-barp]', root);

    // Gallery
    var track = $('[data-gal-track]', root), thumbs = $$('[data-gal-to]', root), slides = $$('[data-gal-slide]', root);
    function playActive(i) {
      slides.forEach(function (s, k) { var v = $('video', s); if (!v) return; if (k === i) { v.play && v.play().catch(function () {}); } else if (!v.paused) v.pause(); });
    }
    if (track) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { var i = +t.dataset.galTo; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio > 0.6) {
              var i = slides.indexOf(en.target);
              thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
              playActive(i);
            }
          });
        }, { root: track, threshold: [0.6] });
        slides.forEach(function (s) { io.observe(s); });
      }
    }

    // Quantities
    function rows() { return $$('[data-pdp-row]', root); }
    function qOf(r) { var i = $('[data-qty-i]', r); return i ? Math.max(0, parseInt(i.value, 10) || 0) : 0; }
    $$('[data-qty]', root).forEach(function (q) {
      var i = $('[data-qty-i]', q), min = +(i.min || 0);
      $('[data-qty-d]', q).addEventListener('click', function () { i.value = Math.max(min, (parseInt(i.value, 10) || 0) - 1); upd(); });
      $('[data-qty-u]', q).addEventListener('click', function () { i.value = Math.min(24, (parseInt(i.value, 10) || 0) + 1); upd(); });
      i.addEventListener('input', upd);
    });
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex], r = rows()[0];
      r.dataset.id = sel.value; r.dataset.price = o.dataset.price; upd();
    });
    $$('[data-pdp-plan]', root).forEach(function (p) { p.addEventListener('change', upd); });
    function plan() { var p = $('[data-pdp-plan]:checked', root); return p && p.value ? p : null; }

    function upd() {
      var n = 0, c = 0, pl = plan(), pct = pl ? (+pl.dataset.pct || 0) : 0;
      rows().forEach(function (r) { var q = qOf(r); n += q; c += q * (+r.dataset.price || 0); });
      c = Math.round(c * (1 - pct / 100));
      var hq0 = form && form.querySelector('[data-pdp-hq]'), r00 = rows()[0]; if (hq0 && r00) hq0.value = Math.max(1, qOf(r00));
      if (tot) tot.textContent = n > 0 ? ' · ' + money(c, cfg.money) : '';
      if (addBtn && cfg.kind !== undefined) addBtn.disabled = n === 0;
      if (price && cfg.kind !== 'season') { var r0 = rows()[0]; if (r0) price.textContent = money(Math.round(+r0.dataset.price * (1 - pct / 100)), cfg.money); }
      if (barp) barp.textContent = n > 0 ? (cfg.kind === 'season' ? n + ' loaf' + (n === 1 ? '' : 'ves') + ' · ' : '') + money(c, cfg.money) : '';
      if (!nudge) return;
      if (cfg.loaf) {
        var left = cfg.gift - (n % cfg.gift === 0 && n > 0 ? cfg.gift : n % cfg.gift);
        nudge.className = 'lp2-pdp__nudge' + (n >= cfg.gift ? ' is-ok' : '');
        nudge.textContent = n >= cfg.gift ? 'Free shipping + a free 6-pack of cookies unlocked.' : (n === 0 ? 'Pick at least one loaf.' : 'Add ' + left + ' more loa' + (left === 1 ? 'f' : 'ves') + ' for free shipping + free cookies.');
      } else if (cfg.ship) {
        var gap = cfg.ship - c;
        nudge.className = 'lp2-pdp__nudge' + (gap <= 0 ? ' is-ok' : '');
        nudge.textContent = gap <= 0 ? 'This order ships free.' : money(gap, cfg.money) + ' away from free shipping.';
      }
    }
    upd();

    function submit(e) {
      if (e) e.preventDefault();
      var pl = plan(), items = [], sp = form && form.querySelector('[name="selling_plan"]'), spv = pl ? +pl.value : (sp && sp.value ? +sp.value : 0);
      rows().forEach(function (r) { var q = qOf(r); if (q > 0) { var it = { id: +r.dataset.id, quantity: q }; if (spv) it.selling_plan = spv; items.push(it); } });
      // Subscription apps (Seal) read name=id / name=quantity from the form; keep them in sync with the first row.
      var hid = form && form.querySelector('[data-pdp-hid]'), hq = form && form.querySelector('[data-pdp-hq]');
      if (hid && items[0]) { hid.value = items[0].id; if (hq) hq.value = items[0].quantity; }
      if (!items.length) { if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      err.hidden = true; addBtn.disabled = true; addBtn.classList.add('is-busy');
      addItems(items).catch(function (x) {
        err.textContent = (x && (x.description || x.message)) || 'Something went wrong. Please try again.'; err.hidden = false;
      }).then(function () { addBtn.disabled = false; addBtn.classList.remove('is-busy'); });
    }
    // Capture phase so our multi-item add (and the cart drawer) runs before subscription apps that hijack product-form submits.
    if (form) window.addEventListener('submit', function (e) { if (e.target === form) { e.stopImmediatePropagation(); submit(e); } }, true);
    if (addBtn) window.addEventListener('click', function (e) { if (addBtn.contains(e.target)) { e.preventDefault(); e.stopImmediatePropagation(); submit(); } }, true);

    // Sticky mobile bar
    var bar = $('[data-pdp-bar]', root), barBtn = $('[data-pdp-baradd]', root);
    if (bar && addBtn && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (es) {
        var en = es[0]; if (en.isIntersecting) seen = true;
        var on = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (barBtn) barBtn.tabIndex = on ? 0 : -1;
      }).observe(addBtn);
      if (barBtn) barBtn.addEventListener('click', function () { if (cfg.kind === 'season') form.scrollIntoView({ behavior: 'smooth', block: 'start' }); else submit(); });
    }
  }

  function init() { nav(); quick(); pdp(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
